import { render } from "./PanelInformativo.vue?vue&type=template&id=10974368&scoped=true"
import script from "./PanelInformativo.vue?vue&type=script&lang=js"
export * from "./PanelInformativo.vue?vue&type=script&lang=js"

import "./PanelInformativo.vue?vue&type=style&index=0&id=10974368&scoped=true&lang=css"

import exportComponent from "/home/runner/work/pizarraResultados/pizarraResultados/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10974368"]])

export default __exports__